import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction, RelatedProducts } from '~/app/tracking/feld-m-types';
import { ConfiguredCarFeature } from '~/graphql/__generated__/graphql';

export type ConflictClickEventParams = {
	selectedItem: ConfiguredCarFeature;
	priceChange: number;
	newTotalPrice: string;
	eventName: string;
	elementName: string;
	elementValue: string;
	label: string;
	relatedProducts?: RelatedProducts;
	clickId?: string;
};

export class ConflictSelectItem extends BaseEvent {
	constructor({
		priceChange,
		newTotalPrice,
		selectedItem,
		label,
		eventName,
		elementName,
		elementValue,
		relatedProducts,
		clickId,
	}: ConflictClickEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Content,
				eventName,
			},
			attributes: {
				componentName: 'configuration-assistant',
				label,
				clickID: clickId || '',
				elementName,
				value: `${Math.abs(selectedItem.price?.value || 0)}`,

				relatedElements: [{ elementName: 'solution group', elementValue }],
				relatedProducts,
			},
			additionalObjects: {
				componentInfo: {
					componentID: 7,
				},
				attributes: {
					implementer: 1,
					version: '1.0.0',
					priceChange: priceChange > 0 ? `+${priceChange}` : `${priceChange}`,
					totalPrice: newTotalPrice,
					solutionGroup: [{ name: elementValue }],
				},
				page: {
					pageInfo: {
						pageID: `configuration assistant - conflict layer`,
					},
				},
			},
		});
	}
}
